import { createReducer } from '@reduxjs/toolkit';
import getConstantsByFeatureName from './getConstantsByFeatureName';
import getActionCreators from './getActionCreators';
import getActionHandlers from './getActionHandlers';
import getSelectorByFeatureName from './getSelectorByFeatureName';
import { initialState } from './commonActionHandlers';

// RTK 2.x removed the object-initializer form of `createReducer`
// (was `createReducer(initialState, handlersMap)`); only the builder
// callback form is supported. The codebase's existing handler shape
// is the redux-actions `{ [actionType]: handler }` map; we pipe it
// through a builder so the central util keeps the same external
// API. Existing handlers are pure `(state, action) => newState` and
// work unchanged (RTK's immer integration is invisible when you
// return a new state).

const buildReducer = (initState, handlers) =>
  createReducer(initState, (builder) => {
    Object.entries(handlers).forEach(([type, handler]) => {
      builder.addCase(type, handler);
    });
  });

export default (featureName, reduxStatePropertyName, initState = initialState) => {
  const constants = getConstantsByFeatureName(featureName);
  const actions = getActionCreators(constants);
  const actionHandlers = getActionHandlers(constants);
  const reducer = buildReducer(initState, actionHandlers);
  const selector = reduxStatePropertyName
    ? getSelectorByFeatureName(reduxStatePropertyName)
    : undefined;

  return {
    constants,
    actions,
    reducer,
    selector,
  };
};

export { buildReducer };
